import React from 'react';
import { getDelimiterBorderStyle, getDelimiterColor } from '../../../support/journeyMap/normalizers';

type NormalizedDelimiter = {
  _key: string;
  _x: number;
  _y: number;
  orientation: 'horizontal' | 'vertical';
  style?: string;
  color?: string;
  label?: string;
  width?: number;
};

type Props = {
  delimiters: NormalizedDelimiter[];
  bounds: {
    width: number;
    height: number;
  };
};

const JourneyMapDividerLayer: React.FC<Props> = ({ delimiters, bounds }) => {
  return (
    <>
      {delimiters.map((delimiter) => {
        const color = getDelimiterColor(delimiter.color);
        const borderStyle = getDelimiterBorderStyle(delimiter.style);
        const isVertical = delimiter.orientation === 'vertical';
        const thickness = Math.max(1, Number(delimiter.width || 4));

        return (
          <div
            key={delimiter._key}
            style={{
              position: 'absolute',
              left: isVertical ? `${delimiter._x}px` : '0px',
              top: isVertical ? '0px' : `${delimiter._y}px`,
              width: isVertical ? `${thickness}px` : `${bounds.width}px`,
              height: isVertical ? `${bounds.height}px` : `${thickness}px`,
              borderLeft: isVertical ? `${thickness}px ${borderStyle} ${color}` : undefined,
              borderTop: !isVertical ? `${thickness}px ${borderStyle} ${color}` : undefined,
              boxSizing: 'border-box',
              pointerEvents: 'none',
              zIndex: 2,
            }}
          >
            {delimiter.label ? (
              <div
                style={{
                  position: 'absolute',
                  top: isVertical ? '8px' : '-30px',
                  left: isVertical ? '8px' : '12px',
                  padding: '4px 10px',
                  borderRadius: '999px',
                  fontSize: '12px',
                  fontWeight: 600,
                  lineHeight: 1.2,
                  whiteSpace: 'nowrap',
                  color,
                  background: 'rgba(255,255,255,0.96)',
                  border: `1px solid ${color}`,
                  zIndex: 3,
                }}
              >
                {delimiter.label}
              </div>
            ) : null}
          </div>
        );
      })}
    </>
  );
};

export default JourneyMapDividerLayer;